<mat-dialog-content class="mat-typography" @dialogAnimation>
  @if (showContactDetails) {
  <app-userinfo-contact></app-userinfo-contact>
  }

  @else {
  <mat-stepper #stepper labelPosition="bottom" (selectedIndexChange)="onStepChange($event)">
    <!-- STEP 1 -->
    <mat-step>
      <ng-template matStepLabel>
        @if (!isSmallScreen$()) {👋}
      </ng-template>
      <h2 class="admin-subheader">Hallo {{ownerTitle}} 👋!</h2>
      <p class="admin-text">Wir freuen uns, dass Du hier bist.</p>
      <p class="admin-text">Du siehst gerade eine Vorschau Deiner eigenen professionellen Website+App, die wir
        speziell
        für Dich erstellt haben.</p>
      <p class="admin-text">Diese Website+App ist vollständig funktionsfähig und auf Wunsch innerhalb von 24
        Stunden bereit, Dein
        Geschäft zu unterstützen.</p>
    </mat-step>
    <!-- STEP 2 -->
    <mat-step>
      <ng-template matStepLabel>
        @if (!isSmallScreen$()) {🤔}
      </ng-template>
      <h2 class="admin-subheader">Warum eine Website+App 🤔?</h2>
      <p class="admin-text">Eine professionelle digitale Präsenz bietet Dir und Deinen Kunden viele Vorteile, die Dein
        Geschäft auf das
        nächste Level heben.</p>

      <ul class="custom-list">
        @for(advantage of ADVANTAGES; track $index) {
        <li class="admin-text">
          <div class="row-list">
            <mat-icon class="icon-spacing">check</mat-icon>
            <div class="title-dsecription-container">
              <div class="emphasis">{{advantage.title}}</div>
              <p>{{advantage.description}}</p>
            </div>
          </div>
        </li>
        }
      </ul>
    </mat-step>

    <!-- STEP 3 -->
    <mat-step>
      <ng-template matStepLabel>
        @if (!isSmallScreen$()) {🌻}
      </ng-template>
      <h2 class="admin-subheader">Rundum-Sorglos-Paket 🌻</h2>
      <p class="admin-text">Unser Angebot umfasst alles, was Du für eine professionelle Website+App benötigst.</p>
      <ul class="custom-list">
        @for(feature of FEATURES; track $index) {
        <li class="admin-text">
          <div class="row-list">
            <mat-icon class="icon-spacing">check</mat-icon>
            <div class="title-dsecription-container">
              <div class="emphasis">{{feature.title}}</div>
              <p>{{feature.description}}</p>
            </div>
          </div>
        </li>
        }
      </ul>
      <p class="admin-text">Mehrwert, der überzeugt: Probiere unseren Service einen Monat lang ohne Risiko aus. Wenn Du
        nicht zufrieden bist, entstehen Dir für den ersten Monat keine Kosten.</p>
    </mat-step>

    <!-- <mat-step>
      <ng-template matStepLabel>
        @if (!isSmallScreen$()) {💰}
      </ng-template>
      <h2 class="custom-title-medium">Preise 💰</h2>
      <p class="custom-body-medium">Als Florist arbeitest Du täglich hart, um Deine Kunden glücklich zu machen. Damit Du
        Dich auf Dein Geschäft konzentrieren kannst, übernehmen wir die technische Betreuung Deiner Website+App.</p>

      <div class="subscription-container">
        <mat-button-toggle-group name="paymentFrequency" aria-label="Payment Frequency" [(ngModel)]="selectedFrequency"
          (change)="updatePrice()">
          <mat-button-toggle value="oneyear">Monatlich</mat-button-toggle>
          <mat-button-toggle value="twoyear">Jährlich</mat-button-toggle>
        </mat-button-toggle-group>

        <div class="price-display">
          <div class="price-description">
            <span class="custom-title-medium">Einrichtung</span>
            <span class="custom-label-medium">einmalig</span>
          </div>
          <span class="custom-title-medium"><span class="custom-body-medium strike">200€</span> 0,00€</span>
        </div>

        <div class="price-display">
          <div class="price-description">
            <span class="custom-title-medium">WebDesign</span>
            <span class="custom-label-medium">einmalig</span>
          </div>
          <span class="custom-title-medium"><span class="custom-body-medium strike">900€</span> 0,00€</span>
        </div>

        <div class="price-display">
          <div class="price-description">
            <span class="custom-title-medium">App-Entwicklung</span>
            <span class="custom-label-medium">einmalig</span>
          </div>
          <span class="custom-title-medium"><span class="custom-body-medium strike">3.000€</span> 0,00€</span>
        </div>

        <div class="price-display">
          <div class="price-description">
            <span class="custom-title-medium">Wartung</span>
            <span class="custom-label-medium">monatlich</span>
          </div>
          <span class="custom-title-medium">{{ formatPrice(price) }}</span>
        </div>
      </div>

      <p class="custom-body-medium">Wir haben unsere Preise so gestaltet, dass sie für Dich leicht zu tragen sind: Bereits
        der Verkauf eines halben Blumenstraußes pro Monat deckt die Kosten für deine neue Website+App. </p>
      <p class="custom-body-medium">
        Du wirst sehen, wie schnell sich eine digitale Präsenz durch neue Kunden und besseren Service auszahlt. Eine
        Investition für Dein Geschäft, die sich lohnt!</p>
    </mat-step> -->

    <!-- STEP 4 -->
    <mat-step>
      <ng-template matStepLabel>
        @if (!isSmallScreen$()) {📅}
      </ng-template>
      <h2 class="admin-subheader">So geht's weiter 📅</h2>
      <p class="admin-text">Interessiert an unserem Rundum-Sorglos-Paket? Dann lass uns sprechen!</p>
      <p class="admin-text">Wir wissen, wie wichtig es für lokale Händler ist, pragmatisch zu handeln und einen
        direkten Draht zu den Kunden zu haben. Deshalb bieten auch wir Dir einen direkten Kontakt zu uns an, um deine Fragen zu klären:</p>
      <p class="admin-text">
        Schreib uns einfach und bequem <a href="mailto:{{CONTACT.email}}" class="link">per E-Mail</a> oder <a
          href="https://wa.me/{{CONTACT.mobile}}" class="link">WhatsApp</a> oder ruf uns an unter <a
          href="tel:{{CONTACT.mobile}}" class="link">{{CONTACT.mobile}}</a>.
      </p>
      <p class="admin-text">Wir melden uns dann bei Dir und besprechen alles Weitere.</p>
    </mat-step>
  </mat-stepper>
  }
</mat-dialog-content>

@if (showContactDetails) {
<mat-dialog-actions align="end" class="fixed-actions">
  <button mat-button (click)="hideContact()">Zurück</button>
</mat-dialog-actions>
} @else {
<mat-dialog-actions align="end" class="fixed-actions">
  <div class="navigation-container">
    <button mat-flat-button (click)="showContact()">Kontakt</button>
    <div class="navigation">
      @if (!isFirstStep) {
      <button mat-button (click)="goPrevious()">Zurück</button>

      }
      @if (!isLastStep) {
      <button mat-button (click)="goNext()">Weiter</button>
      } @else {
      <button mat-button (click)="closeDialog()">Fertig</button>
      }
    </div>
  </div>
</mat-dialog-actions>
}